// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 Poster 810mm x 1210mm / 31.89in x 47.64in / 2296px x 3430px @ 72 ppi
 72 DPI: 842 x 1,191 pixels
 Bleed 5mm / 15 px @ 72 ppi
*/

.a3stopPoster_root_VRbFR {
  width: 1191px;
  height: 842px;
  padding: 1px;
  color: white;
  background: var(--background);
  box-sizing: border-box;
}

.a3stopPoster_content_Kgejp {
  flex: 1 1 auto;
  display: flex;
  flex-flow: column;
  overflow: hidden;
}

.a3stopPoster_columns_Dziw_ {
  flex: 1 1 auto;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
}

.a3stopPoster_timetables_sGW32 {
  flex: 0 0 auto;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
}

.a3stopPoster_timetablesContainer_F_8Dd {
  display: flex;
  flex-direction: column;
  width: 100%;
  /* padding-top: 10px; */
}
`, "",{"version":3,"sources":["webpack://./src/components/a3stopPoster/a3stopPoster.css"],"names":[],"mappings":"AAAA;;;;CAIC;;AAED;EACE,aAAa;EACb,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uBAAuB;AACzB","sourcesContent":["/*\r\n Poster 810mm x 1210mm / 31.89in x 47.64in / 2296px x 3430px @ 72 ppi\r\n 72 DPI: 842 x 1,191 pixels\r\n Bleed 5mm / 15 px @ 72 ppi\r\n*/\r\n\r\n.root {\r\n  width: 1191px;\r\n  height: 842px;\r\n  padding: 1px;\r\n  color: white;\r\n  background: var(--background);\r\n  box-sizing: border-box;\r\n}\r\n\r\n.content {\r\n  flex: 1 1 auto;\r\n  display: flex;\r\n  flex-flow: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.columns {\r\n  flex: 1 1 auto;\r\n  display: flex;\r\n  align-items: stretch;\r\n  justify-content: space-between;\r\n}\r\n\r\n.timetables {\r\n  flex: 0 0 auto;\r\n  display: flex;\r\n  align-items: stretch;\r\n  justify-content: space-between;\r\n}\r\n\r\n.timetablesContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n  /* padding-top: 10px; */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `a3stopPoster_root_VRbFR`,
	"content": `a3stopPoster_content_Kgejp`,
	"columns": `a3stopPoster_columns_Dziw_`,
	"timetables": `a3stopPoster_timetables_sGW32`,
	"timetablesContainer": `a3stopPoster_timetablesContainer_F_8Dd`
};
module.exports = ___CSS_LOADER_EXPORT___;
